export default "__VITE_ASSET__MfSXrdn0__"